import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId70201: SiteIdOverrideConfig = {
  flight: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.flight",
      locSubtitleTextToken: "wizard.orbitz.subLabel.flight",
      differentiatedTitles: true,
    },
  },
  package: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.packages",
      locSubtitleTextToken: "wizard.orbitz.subLabel.packages",
      differentiatedTitles: true,
    },
    lobLabels: {
      hotelsLabel: "wizard.Comet.hotel.tab.title.label",
    },
  },
  hotel: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.hotel",
      locSubtitleTextToken: "wizard.orbitz.subLabel.hotel",
      locTitleToken: "wizard.hotel.pwa.expand.icon.title",
      differentiatedTitles: true,
    },
    navigation: {
      tabTitleToken: "wizard.Comet.hotel.tab.title.label",
    },
  },
  lx: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.Activities",
      locSubtitleTextToken: "wizard.orbitz.subLabel.Activities",
      differentiatedTitles: true,
    },
  },
  car: {
    date: {
      maxDaysRange: 329,
    },
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.Cars",
      locSubtitleTextToken: "wizard.orbitz.subLabel.Cars",
      differentiatedTitles: true,
    },
    AARPCheckbox: true,
  },
  cruise: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.orbitz.label.Cruises",
      differentiatedTitles: false,
      visibleLobSubtitle: true,
      locSubtitleVariant: "1-844-730-9892",
    },
  },
};
